import observeRect from '@reach/observe-rect';
import observeWindowRect from './observe-window-rect';

export default (node, cb) => {
  return window && node === window
    ? observeWindowRect(cb)
    : observeRect(node, cb);
};
